import { FormControlLabel, Radio, RadioGroup, } from '@material-ui/core'

import '../../styles.css'

export default function FieldsRadio({
  classes,
  handleInput,
  field,
  formSelected
}) {
  return(
    <div className='body__fields_radio'>
      <RadioGroup
        onChange={evt => handleInput(field.field_id, evt.target.value)}
        required={formSelected.mandatory}
      >
        {field.items.map(item => (
          <div className='body__fields_radioItem'>
            <FormControlLabel
              value={item.value}
              control={<Radio size='small' />}
              label={item.label}
            />
          </div>
        ))}
      </RadioGroup >
    </div>
  )
}